

































import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import DataContainer from "@vuetifyx/common/DataContainer";

export default Vue.extend({
  props: ["item"],
  data() {
    return {
      mode: "view",
      formOptions: null,
      formContainer: new DataContainer(),
      formData: new DataContainer(),
    };
  },
  computed: {
    rows() {
      const purchaseCommands = this.item.purchaseCommands || [];
      return (this.item.purchaseCommandProductCounts || []).map((override) => {
        const purchaseCommand = purchaseCommands.find((pc) => pc._id === override.purchaseCommandId);
        const productItem = (this.item.productItems || []).find((pi) => pi.product?._id === override.productId);
        return {
          purchaseCommandOrderId: purchaseCommand ? purchaseCommand.orderId : override.purchaseCommandId,
          productLabel: productItem ? productItem.product.sku : override.productId,
          countLabel: override.count,
        };
      });
    },
  },
  methods: {
    startEdit() {
      const item = this.item;
      const vm = this;
      this.formData = new DataContainer({
        purchaseCommandProductCounts: (item.purchaseCommandProductCounts || []).map((override) => ({ ...override })),
      });
      this.formContainer = new DataContainer();
      this.formOptions = {
        content: {
          sections: {
            default: {
              fields: {
                purchaseCommandProductCounts: {
                  type: "XArrayInput",
                  attrs: {
                    label: "Số lượng sản phẩm theo từng đơn mua hàng",
                    xOptions: {
                      content: {
                        itemProperties: {
                          purchaseCommandId: {
                            type: "XAutocomplete",
                            attrs: {
                              label: "Đơn mua hàng",
                              "item-value": "_id",
                              "item-text": "orderId",
                              required: true,
                              xOptions: {
                                content: {
                                  async itemsSuggestor(search, value, limit) {
                                    const { items } = await coreApiClient.call("purchaseCommands", "findAll", {
                                      payload: JSON.stringify({
                                        search,
                                        limit,
                                        filters: [
                                          {
                                            key: "_id",
                                            operator: "in",
                                            value,
                                          },
                                        ],
                                      }),
                                    });
                                    return items;
                                  },
                                },
                              },
                            },
                          },
                          productId: {
                            type: "XAutocomplete",
                            attrs: {
                              label: "Sản phẩm",
                              "item-value": "_id",
                              "item-text": "sku",
                              required: true,
                              xOptions: {
                                content: {
                                  async itemsSuggestor(search, value, limit) {
                                    const { items } = await coreApiClient.call("products", "findAll", {
                                      payload: JSON.stringify({
                                        search,
                                        limit,
                                        filters: [
                                          {
                                            key: "countryId",
                                            operator: "equal_to",
                                            value: item.countryId,
                                          },
                                          {
                                            key: "_id",
                                            operator: "in",
                                            value,
                                          },
                                        ],
                                      }),
                                    });
                                    return items;
                                  },
                                },
                              },
                            },
                          },
                          count: {
                            type: "number",
                            attrs: {
                              label: "Số lượng",
                              required: true,
                            },
                          },
                        },
                        template: {
                          formOptions: {
                            content: {
                              colLength: 4,
                            },
                          },
                        },
                      },
                    },
                  },
                  ext: {
                    colLength: 12,
                  },
                },
              },
            },
          },
          actionButtons: {
            cancel: {
              attrs: {
                color: "default",
              },
              content: {
                text: "Hủy",
              },
              on: {
                xClick() {
                  vm.mode = "view";
                },
              },
            },
            save: {
              content: {
                text: "Lưu",
              },
              on: {
                async xClick({ self }) {
                  const form = self.context();
                  const data = form.getData();
                  form.loading.value = true;
                  self.loading.value = true;
                  const result = await coreApiClient.call(
                    "orders",
                    "applyPurchaseCommandCosts",
                    {},
                    {
                      ids: [item._id],
                      purchaseCommandProductCounts: data.purchaseCommandProductCounts,
                    }
                  );
                  if (result) {
                    const { items } = await coreApiClient.call("orders", "findAll", {
                      payload: JSON.stringify({
                        limit: 1,
                        filters: [
                          {
                            key: "_id",
                            operator: "equal_to",
                            value: item._id,
                          },
                        ],
                      }),
                    });
                    if (items && items[0]) {
                      Object.assign(item, items[0]);
                    }
                    vm.mode = "view";
                  }
                  self.loading.value = false;
                  form.loading.value = false;
                },
              },
            },
          },
        },
      };
      this.mode = "edit";
    },
  },
});
